import { Link } from "react-router-dom";
import { Phone, Mail, Instagram } from "lucide-react";
import Logo from "@/components/Logo";
import { scrollToId } from "@/components/Navbar";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 py-14">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid gap-12 md:grid-cols-3">
        <div>
          <Logo size={56} />
          <p className="mt-5 text-xs text-zinc-500 max-w-xs font-light">
            Gourmet hot dogs, neon lights, and a cart that follows the party.
            Rolling the streets since 2026.
          </p>
        </div>

        <nav className="flex flex-col gap-3 text-sm">
          <p className="text-[10px] font-semibold tracking-[0.3em] uppercase text-zinc-600 mb-1">Explore</p>
          {[
            { label: "Menu", target: "menu" },
            { label: "Find the Cart", target: "find-us" },
            { label: "Catering & Events", target: "catering" },
          ].map((link) => (
            <button
              key={link.target}
              data-testid={`footer-link-${link.target}`}
              onClick={() => scrollToId(link.target)}
              className="text-left text-zinc-400 hover:text-disco-yellow transition-colors duration-300"
            >
              {link.label}
            </button>
          ))}
          <Link
            to="/admin/login"
            data-testid="footer-staff-login-link"
            className="text-zinc-600 hover:text-disco-teal transition-colors duration-300 text-xs mt-2"
          >
            Staff Login
          </Link>
        </nav>

        <div className="flex flex-col gap-3 text-sm">
          <p className="text-[10px] font-semibold tracking-[0.3em] uppercase text-zinc-600 mb-1">Talk to us</p>
          <a
            href="tel:+14234630084"
            data-testid="footer-phone-link"
            className="flex items-center gap-3 text-zinc-300 hover:text-disco-yellow transition-colors duration-300"
          >
            <Phone size={15} className="text-disco-yellow" />
            423-463-0084
          </a>
          <a
            href="mailto:Jess@discodogs.info"
            data-testid="footer-email-link"
            className="flex items-center gap-3 text-zinc-300 hover:text-disco-yellow transition-colors duration-300"
          >
            <Mail size={15} className="text-disco-yellow" />
            Jess@discodogs.info
          </a>
          <a
            href="https://instagram.com/discohotdogs"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-instagram-link"
            className="flex items-center gap-3 text-zinc-300 hover:text-disco-lavender transition-colors duration-300"
          >
            <Instagram size={15} className="text-disco-lavender" />
            @discohotdogs
          </a>
          <p className="text-[11px] text-zinc-600 tracking-wide uppercase mt-4">
            Disco Dogs Cart Co. - Est. 2026
          </p>
        </div>
      </div>
    </footer>
  );
}
